export const GET_AVAILABLE_NODES = 'getAvailableNodes';
export const GET_AVAILABLE_TAGS = 'getAvailableTags';
export const GET_AVAILABLE_TEMPLATES = 'getAvailableTemplates';
export const GET_AVAILABLE_VOICES = 'getAvailableVoices';
export const GET_CALL_FLOW_TREES = 'getCallFlowTrees';
export const GET_CALL_FLOW_TREE = 'getCallFlowTree';
export const GET_CALL_FLOW_TREE_REFERENCES = 'getCallFlowTreeReferences';
export const DUPLICATE_CALL_FLOW_TREE = 'duplicateCallFlowTree';
export const DELETE_CALL_FLOW_TREE = 'deleteCallFlowTree';
export const ATTACH_NODE = 'attachNode';
export const UPDATE_NODE = 'updateNode';
export const SAVE_DRAFT = 'saveDraft';
export const SAVE_TREE = 'saveTree';
export const INITIALIZE_CALL_FLOW_TREE = 'initializeCallFlowTree';
export const INITIALIZE_CALL_FLOW_TREE_TEMPLATE = 'initializeCallFlowTreeTemplate';
export const PROCESS_SCENE_ERRORS = 'processSceneErrors';
export const CLONE_AND_SAVE_DRAFT = 'cloneAndSaveDraft';
export const CONVERT_TEXT_TO_SPEECH = 'convertTextToSpeech';
export const RESET_TEXT_TO_SPEECH_STATE = 'resetTextToSpeechState';